<template>
  <section class="reviews-section" :class="{'reviews-section_landing': landing}">
    <div v-if="reviewsPage"
      class="reviews-section__inner">
      <div class="reviews-section__head">
        <app-title :h1="true">
          {{ h1Seo !== null ? h1Seo : "Отзывы" }}
        </app-title>
      </div>

      <ul v-if="reviewsList"
        :key="componentKey"
        class="reviews-section__list">
        <li v-for="(review, index) in reviewsList"
          :key="index"
          class="reviews-section__list-item">
          <ReviewsSectionCard :review="review" :grey="grey" />
        </li>
      </ul>

      <div v-else>
        <span>Отзывы не найдены.</span>
      </div>

      <div class="reviews-section__pages">
        <div class="reviews-section__wrap _left">
          <AppButton class="reviews-section__action new"
            @click="isOpenWriteReviewModal = true">
            Оставить отзыв
          </AppButton>
        </div>
        <div class="reviews-section__wrap _center">
          <AppButton v-if="totalPages > 1"
            :secondary="true"
            class="reviews-section__more"
            @click="showMore">
            Показать еще
          </AppButton>
        </div>

        <div class="reviews-section__wrap _right">

          <PagePagination v-if="totalPages > 1"
            :total-pages="totalPages"
            :total="total"
            :per-page="perPage"
            :current-page="currentPage"
            @pagechanged="onPageChange" />
        </div>
      </div>
    </div>

    <div v-else
      class="reviews-section__inner">
      <div class="reviews-section__header">
        <app-title class="reviews-section__title" :class="{'reviews-section__title-small': landing}">
          Отзывы наших клиентов
        </app-title>

      </div>

      <swiper class="reviews-section__swiper"
        :breakpoints="{
          320: { slidesPerView: 1, centerdSlides: true },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 2 },
          1280: {slidesPerView: 3},
        }"
        :speed="1000"
        :modules="modules"
        :space-between="8"
        :navigation="{ nextEl: '._next', prevEl: '._prev' }">
        <swiper-slide v-for="(review, index) in reviewsList"
          :key="index"
          class="reviews-section__slide">
          <ReviewsSectionCard :review="review" />
        </swiper-slide>
      </swiper>

      <div class="reviews-section__nav-swiper">
        <div class="_prev">
          <app-svg id="arrow-left"
            width="15"
            height="15" />
        </div>
        <div class="_next">
          <app-svg id="arrow-right"
            width="15"
            height="15" />
        </div>
      </div>

      <div class="reviews-section__buttons">
        <AppButton class="reviews-section__action"
          @click="isOpenWriteReviewModal = true">
          Оставить отзыв
        </AppButton>
        <div class="reviews-section__link">
          <AppButton to="/reviews"
            :secondary="true">
            Все отзывы
          </AppButton>
        </div>
      </div>
    </div>

    <teleport v-if="isOpenWriteReviewModal"
      to="body">
      <AppModal v-model="isOpenWriteReviewModal">
        <ModalWriteReview @form-success-sent="formSuccessSent" />
      </AppModal>
    </teleport>
    <teleport v-if="isOpenPopupSuccessfully"
      to="body">
      <PopupSuccessfully title="Отзыв успешно оптравлен!"
        text="Спасибо за обратную связь."
        text-second="Ваше мнение очень важно для нас!"
        @popup-close="isOpenPopupSuccessfully = false" />
    </teleport>


  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper";
import ReviewsSectionCard from "@/components/ReviewsSectionCard.vue";
import AppButton from "@/components/ui/AppButton.vue";
import AppModal from "./ui/AppModal.vue";
import AppLink from "@/components/ui/AppLink.vue";
import ModalWriteReview from "./ModalWriteReview.vue";
import PopupSuccessfully from "@/components/PopupSuccessfully.vue";
import PagePagination from "@/components/ui/PagePagination.vue";

export default {
  name: "ReviewsSection",
  components: {
    Swiper,
    SwiperSlide,
    ReviewsSectionCard,
    AppButton,
    AppModal,
    AppLink,
    ModalWriteReview,
    PopupSuccessfully,
    PagePagination,
  },

  inject: ["h1Seo"],

  props: {
    reviewsPage: {
      type: Boolean,
      default: false,
    },
    grey: {
      type: Boolean,
      default: false,
    },
    landing: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      componentKey: 0,
      currentPage: 1,
      perPage: 9,
      total: 0,
      totalPages: 0,
      isOpenWriteReviewModal: false,
      isOpenPopupSuccessfully: false,
      reviewsList: [],
      aggregateRating: null,
      modules: [Navigation, Pagination],
      agent: this.$route.query.agent,
    };
  },

  watch: {
    "$route.query.page"() {
      this.getReviews(this.$route.query.page !== undefined ? this.$route.query.page : 1);
      this.componentKey += 1;
    },
  },

  beforeMount() {
    this.getReviews(this.$route.query.page !== undefined ? this.$route.query.page : 1);
  },

  methods: {
    onPageChange(page) {
      this.$router.push(
        page == 1
          ? {
            name: "Отзывы",
          }
          : {
            name: "Отзывы",
            query: {
              page: page,
            },
          }
      );
    },

    getReviews(page) {
      this.axios
        .get("/api/reviews", {
          params: {
            page: page,
            limit: this.perPage,
            agent: this.$route.query.agent,
          },
        })
        .then(({ data }) => {
          this.reviewsList = data.data;
          this.currentPage = data.meta.current_page;
          this.total = data.meta.total;
          this.totalPages = Math.ceil(this.total / this.perPage);
          this.aggregateRating = data.aggregate_rating || null;
        });
    },

    showMore() {
      this.perPage += 9;
      this.getReviews();
    },

    formSuccessSent() {
      this.isOpenPopupSuccessfully = true;
      this.isOpenWriteReviewModal = false;

      setTimeout(() => {
        this.isOpenPopupSuccessfully = false;
      }, 4000);
    },
  },
};
</script>

<style lang="scss" scoped>
.reviews-section {
  $that: &;

  background-color: #F6F6F6;
  overflow: hidden;
  position: relative;
  padding: 64px 0;

  &_landing {
    background-color: transparent;
  }

  .reviews-page & {
    padding: 0;
    overflow: visible;
  }

  @include laptop {
    padding: 48px 0;
  }

  @include phone {
    padding-bottom: 120px;
  }

  &__inner {
    @extend %container;

    .reviews-page & {
      @extend %container;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__nav-swiper {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex: none;
    display: flex;
    gap: 10px;
    color: $color_primary;

    ._prev,
    ._next {
      cursor: pointer;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid $color_orange-50;
      display: flex;
      align-items: center;
      justify-content: center;

      &.swiper-button-disabled {
        color: $color_grey-15;
        border-color: $color_grey-15;
      }

      flex: none;
      transition: color 0.3s ease,
      border 0.3s ease;

      @include phone {
        width: 32px;
        height: 32px;

        svg {
          width: 12px;
          height: 12px;
        }
      }
    }

    @include phone {
      justify-content: space-between;
      margin-top: 28px;
    }
  }

  &__swiper {
    overflow: visible;
    margin: 0 -16px;

    @include desktop {
      margin: 0 -10px;
    }

    @include phone {
      margin: 0;
    }
  }

  &__slide {
    padding: 0 16px;
    opacity: 0;
    transition: opacity 0.25s 0.5s ease;

    &.swiper-slide-active {
      opacity: 1;
      transition: opacity 0.25s ease;

      &+#{$that}__slide {
        opacity: 1;
        transition: opacity 0.25s ease;

        @include phone {
          opacity: 0;
        }
      }

      &+#{$that}__slide+#{$that}__slide {
        opacity: 1;
        transition: opacity 0.25s ease;

        @include tablet {
          opacity: 0;
        }
      }
    }

    @include desktop {
      padding: 0 10px;
    }

    @include phone {
      padding: 0;
    }
  }

  &__pagination {
    padding: 12px 0;

    @media (min-width: 640px) {
      display: none;
    }
  }

  &__bottom {
    position: relative;
    display: flex;
    justify-content: center;
    margin: 64px auto 0;

    @include laptop {
      margin: 30px auto 0;
    }

    @include phone {
      flex-direction: column;
    }
  }

  &__buttons {
    position: absolute;
    bottom: 64px;
    display: flex;
    justify-content: space-between;
    left: 0;
    right: 0;
    @extend %container;
    pointer-events: none;

    & * {
      pointer-events: all;
    }

    @include phone {
      max-width: max-content;
      flex-direction: column-reverse;
      align-items: center;
      gap: 28px;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
      padding: 0;

      .button {
        max-width: 180px;
        width: 100%;
      }
    }
  }

  &__link {
    @include phone {
      width: 100%;
      position: static;
      transform: none;
      display: flex;
      justify-content: center;
      margin-top: 0;
    }
  }

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 32px;

    @include phone {
      flex-direction: column;
      align-items: flex-start;

      h1 {
        font-size: 32px;
        line-height: 120%;
      }

      h2 {
        padding-bottom: 32px;
      }
    }

    h1 {

    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;
  }

  &__list-item {
    flex: 0 0 calc((100% / 3) - 9px);

    @include laptop {
      flex: 0 0 calc(50% - 9px);
    }

    @include tablet {
      flex: 1 1 100%;
    }
  }

  &__wrap {
    display: flex;
    align-items: center;

    &._left {
      justify-content: flex-start;

      @include phone {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &._center {
      justify-content: center;
    }

    &._right {
      justify-content: flex-end;
    }
  }

  &__pages {
    position: relative;
    margin-top: 64px;

    @include flex-center;

    @include tablet {
      // flex-direction: column;
      justify-content: space-between;
      margin-top: 30px;
      padding-bottom: 50px;
    }

    .reviews-page & {
      display: flex;
      align-items: center;

      &>* {
        flex: 0 0 33%;

        @include phone {
          flex: none;
        }
      }
    }

    .new {
      position: absolute;
      left: 0;

      .reviews-page & {
        position: static;
      }
    }

    @include tablet {
      position: static;
    }

    .page-pagination {
      position: absolute;
      right: 0;

      // @include tablet {
      //   position: static;
      //   margin-top: 24px;
      // }

      .reviews-page & {
        position: static;
      }
    }
  }

  &__action {
    padding: 16px 60px;

    @include phone {
      height: 32px;
      padding: 8px 20px;
    }
  }

  &__link {
    & > * {
      padding: 16px 60px;

      @include phone {
        height: 32px;
        padding: 8px 20px;
      }
    }
  }

  &__more {
    padding: 16px 50px;

    .reviews-page & {
      flex-grow: 0;
      width: 250px;
      align-self: center;

      @include phone {
        width: auto;
        height: 32px;
        padding: 10px 20px;
      }
    }
  }

  &__title {
    &-small {
      font-size: 30px !important;
      line-height: 1 !important;
      font-weight: bold;
    }
  }
}
</style>
